import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilingNoteComponent } from 'src/app/components/filing-note/filing-note.component';
import { DialogModule } from 'primeng/dialog';



@NgModule({
  declarations: [
    FilingNoteComponent
  ],
  imports: [
    CommonModule,
    DialogModule,
  ],
  exports: [
    FilingNoteComponent
  ]
})
export class ProcessCommonModuleModule { }
